import { Injectable } from '@angular/core';
import { CanActivate, ActivatedRouteSnapshot, RouterStateSnapshot, Router } from '@angular/router';
import { AuthService } from '../services/auth.service';
import { PermissionService } from '../services/permission.service';

@Injectable({
  providedIn: 'root'
})
export class RoleGuard implements CanActivate {
  
  constructor(
    private authService: AuthService,
    private permissionService: PermissionService,
    private router: Router
  ) {}
  
  canActivate(route: ActivatedRouteSnapshot, state: RouterStateSnapshot): boolean {
    const user = this.authService.getCurrentUser();
    
    if (!user) {
      this.router.navigate(['/login']);
      return false;
    }

    const allowedRoles = route.data['roles'] as Array<string>;
    if (allowedRoles && allowedRoles.length > 0) {
      const userRole = (user.role || '').toLowerCase().replace(/^role_/, '');
      if (!allowedRoles.map((r: string) => r.toLowerCase()).includes(userRole)) {
        this.router.navigate(['/unauthorised']);
        return false;
      }
    }

    if (!this.permissionService.isRouteAllowed(state.url)) {
      const requiredModule = route.data['module'] as string;
      if (!requiredModule || !this.permissionService.canViewModule(requiredModule)) {
        this.router.navigate(['/unauthorised']);
        return false;
      }
    }
    
    return true;
  }
}
